import Vue from 'vue'
import './assets/css/normalize.css'
import './assets/css/global.scss'
import './assets/font/font.scss'

import App from './App.vue'
import router from './router'

//导入全局基础组件和变量
import '@/utils/base.js'

//全局变量
import global from '@/utils/global.js';

Vue.prototype.$global = global

Vue.config.productionTip = false

Vue.directive('focus', {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function (el) {
    // 聚焦元素
    el.focus()
  }
})

new Vue({
  data:{
    global
  },
  router,
  render: h => h(App)
}).$mount('#app')
